export default __webpack_public_path__ + "static/media/desk.4a572b36.png";